import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { NotificationsService, ProcessedNotification } from '../../services/notifications.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications',
  imports: [CommonModule],
  templateUrl: './notifications.html',
  styleUrl: './notifications.css'
})
export class NotificationsComponent implements OnInit, OnDestroy {
  @Input() isVisible: boolean = false;
  @Output() closePanel = new EventEmitter<void>();
  @Output() createNewGoal = new EventEmitter<void>();

  public notifications: ProcessedNotification[] = [];
  public unreadCount: number = 0;
  private subscriptions = new Subscription();

  constructor(private notificationsService: NotificationsService,
    private router:Router
  ) {}

  ngOnInit(): void {
    // Suscribirse a las notificaciones del servicio
    this.subscriptions.add(
      this.notificationsService.notifications$.subscribe(notifications => {
        this.notifications = notifications;
      })
    );

    // Suscribirse al contador de no leídas
    this.subscriptions.add(
      this.notificationsService.unreadCount$.subscribe(count => {
        this.unreadCount = count;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getNotificationIcon(type: string): string {
    return this.notificationsService.getNotificationIcon(type);
  }

  getNotificationClass(type: string): string {
    return this.notificationsService.getNotificationClass(type);
  }


  markAsRead(notification: ProcessedNotification): void {
    this.notificationsService.markAsRead(notification.id);
    if (notification.actionUrl) {
      this.router.navigateByUrl(notification.actionUrl);
    }
  }

  markAllAsRead(): void {
    this.notificationsService.markAllAsRead();
  }

  deleteNotification(notificationId: string): void {
    this.notificationsService.deleteNotification(notificationId);
  }

  onCreateNewGoal(): void {
    this.createNewGoal.emit();
    this.closePanel.emit();
  }

  onClose(): void {
    this.closePanel.emit();
  }

  onViewMore(): void {
    // Aquí puedes navegar a una página de notificaciones completa
    console.log('Ver más notificaciones');
  }
}